import * as React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CardItem = ({ data }) => {
  const { t } = useTranslation();
  const detailLink = "/products/detail/" + data.id;

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Chip label={data.category} size="small" />
            <Typography sx={{ fontSize: 14 }} color="text.secondary">
              {data.author}
            </Typography>
          </Stack>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {data.updateDate}
          </Typography>
        </Stack>
        <Typography variant="h5" component="div" gutterBottom>
          {data.name}
        </Typography>

        <Typography
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
          }}
          variant="body2"
        >
          {data.content}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" component={Link} to={detailLink}>
          {t("nav2-card-more")}
        </Button>
      </CardActions>
    </Card>
  );
};

CardItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    author: PropTypes.string,
    category: PropTypes.string,
    content: PropTypes.string,
    updateDate: PropTypes.string,
  }),
};

export default CardItem;
